"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = void 0;
var common_sidecar_1 = require("../../../main/common-sidecar");
var buttons2_sidecar_1 = require("../../../uiParts/buttons2-sidecar");
var clickEater_sidecar_1 = require("../../../uiParts/clickEater-sidecar");
var stevieTexts2_sidecar_1 = require("../../../uiParts/stevieTexts2-sidecar");
var rogueCamera_sidecar_1 = require("../camera/rogueCamera-sidecar");
require("../ui/rogueCursor-sidecar");
var rogueRunner_sidecar_1 = require("./rogueRunner-sidecar");
var update = function (time, delta) {
    // let ctx = goatScene.getContext()
    common_sidecar_1.common.setUpdateDelta(delta / 1000);
    var curSpeedScale = 1;
    //  physics.updateAll()
    // physicsDebug.updateAll()
    common_sidecar_1.common.setUpdateDeltaScaled((delta / 1000) * curSpeedScale);
    // updatePipelines.updateUniform()
    // uiFps.update(goatCamera.getGameBounds())
    // cardCards.sortCards()
    // cardCursor.update()
    rogueCamera_sidecar_1.rogueCamera.update();
    // cardBackpack.update()
    // cardBlueprintsList.update()
    // cardCards.updateAll()
    // relayoutHabitats()
    // cardCards.sortCards()
    // Process input if any
    rogueRunner_sidecar_1.rogueRunner.runRogue();
    rogueRunner_sidecar_1.rogueRunner.drawAll();
    buttons2_sidecar_1.buttons2.updateAll();
    stevieTexts2_sidecar_1.stevieTexts2.updateAll();
    clickEater_sidecar_1.clickEater.updateAll();
};
exports.update = update;
